import { adminApi } from "../admin/api";

export const studioApi = {
  async generateCopy({ template, topic, service, tone }) {
    const { data } = await adminApi.post("/studio/generate-copy", { template, topic, service, tone });
    return data; // { headline, subtitle, cta, template }
  },
  async variantCopy({ template, headline, subtitle, cta, author, service }) {
    const { data } = await adminApi.post(
      "/studio/variant-copy",
      { template, headline, subtitle, cta, author, service },
      { timeout: 60000 }
    );
    return data; // { headline, subtitle, cta, template }
  },
  async generateImage({ prompt, model, aspect }) {
    const { data } = await adminApi.post(
      "/studio/generate-image",
      { prompt, model, aspect },
      { timeout: 120000 }
    );
    return data; // { image_base64, model, mime_type }
  },
  async saveAsset(payload) {
    const { data } = await adminApi.post("/studio/assets", payload, { timeout: 30000 });
    return data; // StudioAssetSummary
  },
  async listAssets({ limit = 24, skip = 0 } = {}) {
    const { data } = await adminApi.get("/studio/assets", { params: { limit, skip } });
    return data; // { total, items, limit, skip }
  },
  async getAsset(id) {
    const { data } = await adminApi.get(`/studio/assets/${id}`);
    return data; // full StudioAsset with background_base64
  },
  async deleteAsset(id) {
    await adminApi.delete(`/studio/assets/${id}`);
  },
};
